import { ReactNode } from "react";
import { usePublicPage } from "./usePublicPage";
import { PublicFooter } from "./PublicFooter";
import { SiteHeader } from "./SiteHeader";
import s from "./site.module.scss";

/**
 * Frame of the seven menu pages (boards 308–311): the same panel look across the top (a light map grid with one thin teal route line, boards 355-358),
 * the page's words on a white sheet that rises over it. The pages' own markup and wording are today's; `site.module.scss` calms their glass cards.
 */
export const SiteFrame = ({ children }: { children: ReactNode }) => {
  usePublicPage();
  return (
    <div className={`cy-next cy-public ${s.site}`}>
      <div className={s.top} aria-hidden="true">
        <svg className={s.topRoute} viewBox="0 0 1440 200" preserveAspectRatio="none" focusable="false">
          <path d="M-20 130 C 260 50, 620 170, 960 90 S 1340 50, 1470 80" fill="none" strokeWidth="3" strokeLinecap="round" style={{ stroke: "var(--cy-brand-teal)" }} />
          {[[96, 110], [1330, 66]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="7" strokeWidth="3" style={{ fill: "var(--cy-surface)", stroke: "var(--cy-brand-teal)" }} />)}
        </svg>
      </div>
      <SiteHeader />
      <main className={s.sheet}><div className={s.pageSlot}>{children}</div></main>
      <PublicFooter />
    </div>
  );
};
